import { selectors } from 'modules/common';
import { domain } from 'modules/data';

export const useGetHelpId = (company: selectors.types.ExpandedCompany) => {
    return `reports-line-item-${company.integration?.integrationType || domain.IntegrationType.None}`;
};
